webpackJsonp([43369700788870],{

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mfg-contact_us-min.76876947.png";

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Banner = __webpack_require__(9);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _mfgContact_usMin = __webpack_require__(96);
	
	var _mfgContact_usMin2 = _interopRequireDefault(_mfgContact_usMin);
	
	var _contactUsModule = __webpack_require__(273);
	
	var _contactUsModule2 = _interopRequireDefault(_contactUsModule);
	
	var _gatsbyLink = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// email field validation
	var VALID_EMAIL_PATTERN = /(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+\w$)/;
	var isValidEmail = function isValidEmail(value) {
	  return VALID_EMAIL_PATTERN.test(value);
	};
	
	var ContactUs = function (_Component) {
	  _inherits(ContactUs, _Component);
	
	  function ContactUs(props) {
	    _classCallCheck(this, ContactUs);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      isEmailValid: false,
	      emailInput: ''
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleReset = _this.handleReset.bind(_this);
	    return _this;
	  }
	
	  ContactUs.prototype.handleChange = function handleChange(e) {
	    var emailInput = e.target.value;
	
	    if (isValidEmail(emailInput)) {
	      this.setState({
	        isEmailValid: true,
	        emailInput: emailInput
	      });
	    } else {
	      this.setState({
	        isEmailValid: false,
	        emailInput: emailInput
	      });
	    }
	  };
	
	  // not working in IE11, perhaps with 'onClick' polyfill?
	
	
	  ContactUs.prototype.handleReset = function handleReset(e) {
	    e.preventDefault();
	
	    document.getElementById('contact-form-v2').reset();
	
	    this.setState({
	      isEmailValid: false,
	      emailInput: ''
	    });
	  };
	
	  ContactUs.prototype.handleFormSubmission = function handleFormSubmission(e) {
	    e.preventDefault();
	    var myForm = document.getElementById('contact-form-v2');
	    var formData = new FormData(myForm);
	    fetch("/", {
	      method: "POST",
	      headers: { "Content-Type": "application/x-www-form-urlencoded" },
	      body: new URLSearchParams(formData).toString()
	    }).then(function () {
	      console.log('Form Submitted');
	      (0, _gatsbyLink.navigateTo)('/success-contact-us');
	    }).catch(function () {});
	  };
	
	  ContactUs.prototype.render = function render() {
	    var _state = this.state,
	        isEmailValid = _state.isEmailValid,
	        emailInput = _state.emailInput;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: _contactUsModule2.default.contactUsContainer },
	      _react2.default.createElement(_Banner2.default, { src: _mfgContact_usMin2.default, caption: 'Build With Us.' }),
	      _react2.default.createElement(
	        'div',
	        { className: _contactUsModule2.default.stdContent },
	        _react2.default.createElement(
	          'div',
	          { className: _contactUsModule2.default.left },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Email Us'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'To find out if a relationship with Empire is right for you, please contact us today.'
	          ),
	          _react2.default.createElement(
	            'form',
	            {
	              id: 'contact-form-v2',
	              name: 'contact',
	              method: 'POST',
	              'data-netlify': 'true',
	              'data-netlify-recaptcha': 'true',
	              'netlify-honeypot': 'bot-field'
	            },
	            _react2.default.createElement(
	              'div',
	              { className: _contactUsModule2.default.section },
	              _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contact' }),
	              _react2.default.createElement(
	                'div',
	                { className: _contactUsModule2.default.field },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'name' },
	                  'Full Name'
	                ),
	                _react2.default.createElement('input', { id: 'name', name: 'name', type: 'text' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _contactUsModule2.default.field },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'company' },
	                  'Company'
	                ),
	                _react2.default.createElement('input', { id: 'company', name: 'company', type: 'text' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _contactUsModule2.default.field },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'email' },
	                  'Email Address'
	                ),
	                _react2.default.createElement('input', { id: 'email', name: 'email', type: 'email', value: emailInput, onChange: this.handleChange })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _contactUsModule2.default.field },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'questions-comments' },
	                  'Questions / Comments'
	                ),
	                _react2.default.createElement('textarea', { id: 'questions-comments', name: 'questions-comments' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _contactUsModule2.default.field },
	                _react2.default.createElement(
	                  'p',
	                  { className: _contactUsModule2.default.recaptcha },
	                  'Please check reCAPTCHA box before clicking Submit.'
	                )
	              ),
	              _react2.default.createElement('div', { 'data-netlify-recaptcha': 'true' }),
	              _react2.default.createElement(
	                'div',
	                { className: _contactUsModule2.default.field },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: isEmailValid ? _contactUsModule2.default.submit : _contactUsModule2.default.disabled,
	                    type: 'submit',
	                    disabled: !isEmailValid,
	                    title: 'Please submit with a valid email address',
	                    onClick: this.handleFormSubmission
	                  },
	                  'Submit'
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: _contactUsModule2.default.clear, onClick: this.handleReset },
	                  'Clear'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _contactUsModule2.default.right },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Our Office'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _contactUsModule2.default.map },
	            _react2.default.createElement('iframe', { src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.5385267733996!2d-74.01589668459518!3d40.70615997933263!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a173d1b444d%3A0x7775ebc6ec42bcd0!2sEmpire+Asset+Management!5e0!3m2!1sen!2sus!4v1527069949906', width: '588', height: '300', frameBorder: '0', style: { border: '0' }, allowFullScreen: true })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _contactUsModule2.default.section },
	            _react2.default.createElement(
	              'div',
	              { className: _contactUsModule2.default.address },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Address:'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '29 Broadway'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '12th Floor'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'New York, NY 10006'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Phone:'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '888.417.8050'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '212.417.7777'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Email:'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:info@empiream.com' },
	                    'info@empiream.com'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ContactUs;
	}(_react.Component);
	
	exports.default = ContactUs;
	module.exports = exports['default'];

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contactUsContainer":"src-pages----contact-us-module---contactUsContainer---2joGL","stdContent":"src-pages----contact-us-module---stdContent---3meNM","left":"src-pages----contact-us-module---left---3hpOa","right":"src-pages----contact-us-module---right---3JOzj","map":"src-pages----contact-us-module---map---gltAQ","section":"src-pages----contact-us-module---section---3dj9d","field":"src-pages----contact-us-module---field---1QK4v","recaptcha":"src-pages----contact-us-module---recaptcha---2wNPK","submit":"src-pages----contact-us-module---submit---3Qog4","disabled":"src-pages----contact-us-module---disabled---3Tl0F","clear":"src-pages----contact-us-module---clear---38zF7","address":"src-pages----contact-us-module---address---1Mwvn","callout":"src-pages----contact-us-module---callout---2sblf","hidden":"src-pages----contact-us-module---hidden---1kWWZ"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-us-js-bc26bf87de02b7008352.js